import {
  Component,
  Event, EventEmitter,
  Host, h,
  Listen,
  Method, Watch,
  Prop, State
} from '@stencil/core';

const inputState = {
  ENABLED: "enabled",
  ACTIVE: "active",
  FOCUS: "focus"
}

@Component({
  tag: 'cr-input',
  styleUrl: 'cr-input.css',
  shadow: true,
})
export class CrInput {

  /**
   * Text that informs the user about the content they need to enter in the
   * field
   * @type string
   */
  @Prop() label: string = ""

  /**
   * Assistive text that can provide additional aid or context to the user.
   * @type string
   */
  @Prop() helperText: string = ""

  /**
   * The content the user has entered into the field.
   * @type string
   */
  @Prop() value: string = ""

  /**
   * Responds to small (sm) and large (lg); all other values default to
   * medium (md)
   * @type string
   */
  @Prop() size: string = ""

  /**
   * placeholder text
   * @type {string}
   */
  @Prop() placeholder: string = ''

  @Watch('value')
  updateValue() {
    this._value = this.value
  }

  /**
   * Focus on the input.
   */
  @Method()
  async grabFocus() {
    setTimeout(() => {this.textInput.focus()}, 200)
  }

  /**
   * Emits internal input element's input event beyond the shadow dom.
   * @type EventEmitter
   */
  @Event() forminput: EventEmitter<string>;

  /**
   * Emits internal input element's focus event beyond the shadow dom
   * @type EventEmitter
   */
  @Event() formfocus: EventEmitter<any>;

  /**
   * Emits internal input element's blur event beyond the shadow dom
   * @type EventEmitter
   */
  @Event() formblur: EventEmitter<any>;

  @State() state: string = inputState.ENABLED

  @Listen('input')
  handleInputInput(ev: InputEvent) {
    ev.preventDefault()
    this.state = inputState.ACTIVE
    this._value = this.textInput.value
    this.forminput.emit(this._value)
  }

  @Listen('focus')
  handleInputFocus(ev: FocusEvent) {
    ev.preventDefault()
    this.state = inputState.FOCUS
    this.formfocus.emit()
  }

  @Listen('blur')
  handleInputBlur(ev: FocusEvent) {
    ev.preventDefault()
    this.state = inputState.ENABLED
    this.formblur.emit()
  }


  render() {
    return (
      <Host>
        <div part="wrapper" class={`wrapper`}>
          {this.label.length > 0
            ? (<div part="label" class={`label`}>
              <label htmlFor="inputName">{this.label}</label>
            </div>)
            : null
          }

          <div part="field" class={`field ${this.state}`}>
            <input id="input" part="input" class={`input ${this.size}`}
              ref={(el) => this.textInput = el as HTMLInputElement}
              name="inputName"
              type="text"
              placeholder={this.placeholder}
              value={this.value}
            />
            <slot name="icon"></slot>
          </div>
          <div part="helperText" class={`helper-text`}>{this.helperText}</div>
        </div>
      </Host>
    );
  }

  private textInput!: HTMLInputElement

  private _value: string

}
